import { useQuery, keepPreviousData, type UseQueryResult } from '@tanstack/react-query';
import type { ListEnvelope } from '../../../shared/api/genexus-query';
import type { DataTableQuery } from '../../../shared/components/DataTable';
import { listNotasMae, listPendentesFaturamento } from './api';
import type { NotaFiscalColabPendenteItem, NotaMaeOption } from './types';

export function usePendentesFaturamento(
  query: DataTableQuery,
): UseQueryResult<ListEnvelope<NotaFiscalColabPendenteItem>> {
  return useQuery({
    queryKey: ['nf-empresa-gerar', 'pendentes-faturamento', query],
    queryFn: () => listPendentesFaturamento(query),
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
}

export function useNotasMae(companyId: number | null): UseQueryResult<NotaMaeOption[]> {
  return useQuery({
    queryKey: ['nf-empresa-gerar', 'notas-mae', companyId],
    queryFn: () => listNotasMae(companyId as number),
    enabled: companyId !== null && companyId > 0,
    staleTime: 60_000,
  });
}
